import React from 'react';
import { Col, Row } from 'reactstrap';
import PdfPreviewCard from '../../../components/PdfPreviewCard';
import { PdfType } from '../../../utils/Types';

interface IPdfsPreviewProps {
  pdfs: PdfType[];
  handleRemove: (id: number | string) => void;
}

const PdfsPreview: React.FC<IPdfsPreviewProps> = ({ pdfs, handleRemove }) => {
  return (
    <div>
      {pdfs.length > 0 ? (
        <Row>
          {pdfs.map((pdf) => (
            <Col lg={4} md={6} sm={6} xs={12} key={pdf.id}>
              <PdfPreviewCard pdf={pdf} handleRemove={handleRemove} />
            </Col>
          ))}
        </Row>
      ) : (
        ''
      )}
    </div>
  );
};

export default PdfsPreview;
